import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ReturnUrlService } from '../../services/return-url.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const returnUrlService = inject(ReturnUrlService);

  if (authService.isAuthenticated()) {
    return true;
  } else {
    const path = state.url.split('?')[0].replace(/^\/+/, '');
    if (path.startsWith('analytics/high-schools')) {
      returnUrlService.set(state.url);
    }
    router.navigate(['/login']);
    return false;
  }
};
